module.exports = __webpack_public_path__ + "img/headercopy2.58863387.svg";